module.exports = __webpack_public_path__ + "img/lexicon.f30e2aba.png";